import type { LabsSettings } from '../types';

export const LABS_KEY = 'labs_settings';

export const defaultSettings: LabsSettings = {
  debug: false,
  debugNetwork: false,
  workStatusPage: false,
  useTTS: true,
  ttsCheckIn: 'Bem-vindo! Registro de entrada realizado.',
  ttsCheckOut: 'Até logo! Registro de saída realizado.',
  remindToWork: false,
  remindToRest: false,
  remindToLeave: false,
  useMotivationalFeeds: false,
  remindToWorkHour: '08:00',
  remindToWorkDays: [1, 2, 3, 4, 5],
  remindToWorkText: 'Hora de trabalhar!',
  remindToRestHour: '12:00',
  remindToRestDays: [1, 2, 3, 4, 5],
  remindToRestText: 'Hora de descansar!',
  remindToLeaveHour: '18:00',
  remindToLeaveDays: [1, 2, 3, 4, 5],
  remindToLeaveText: 'Hora de ir embora!',
};
